import styled from '@emotion/styled'

import EnergyIcon from '@/assets/icons/energy-disabled.svg?react'
import { SUB_COLOR } from '@/constants/colors'

const TITLE_COLOR = '#1f1f1f'
const TITLE_DISABLED_COLOR = '#acaeb4'
const SUB_DISABLED_COLOR = '#d4d5d8'
const ENERGY_ICON_COLOR = '#acaeb4'
const ENERGY_ICON_DISABLED_COLOR = '#d4d5d8'

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`

export const InfoWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

export const IconImage = styled.img`
  width: 44px;
  height: 44px;
  flex-shrink: 0;
  object-fit: contain;
`

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`

export const Title = styled('span', {
  shouldForwardProp: (prop) => prop !== 'isCompleted',
})<{ isCompleted?: boolean }>`
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.08px;
  color: ${({ isCompleted }) => (isCompleted ? TITLE_DISABLED_COLOR : TITLE_COLOR)};
`

export const SubText = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isCompleted',
})<{ isCompleted?: boolean }>`
  display: flex;
  align-items: center;
  gap: 1px;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.14px;
  color: ${({ isCompleted }) => (isCompleted ? SUB_DISABLED_COLOR : SUB_COLOR)};
`

export const InlineEnergyIcon = styled(EnergyIcon, {
  shouldForwardProp: (prop) => prop !== 'isCompleted',
})<{ isCompleted?: boolean }>`
  width: 12px;
  height: 12px;
  color: ${({ isCompleted }) => (isCompleted ? ENERGY_ICON_DISABLED_COLOR : ENERGY_ICON_COLOR)};
`
